import React from "react";
import PageHero from "../components/PageHero";
import { Award, Target, Heart, Users, ShieldCheck, Sparkles } from "lucide-react";
import { SITE, IMAGES } from "../data/mock";

export default function About() {
  const values = [
    { icon: Heart, title: "User First", desc: "Har faisle me hum users ke faayde ko sabse aage rakhte hain - transparency, fair play aur honesty." },
    { icon: ShieldCheck, title: "Security & Trust", desc: "SSL encryption, KYC verification aur secure payments - aapka data aur paisa dono safe." },
    { icon: Sparkles, title: "Innovation", desc: "Naye games, faster withdrawals aur smarter UI - hum hamesha latest tech use karte hain." },
    { icon: Users, title: "Community", desc: "10,000+ active players ki community jahan har player ko equal respect milta hai." },
  ];
  return (
    <div>
      <PageHero title="About OnlineCricketID.guru" breadcrumb="About Us" subtitle="India ki sabse trusted Cricket ID aur Sports Exchange platform - 2015 se players ka bharosa, ek nayi pehchaan." />

      <section className="section-pad">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 grid lg:grid-cols-2 gap-12 items-center">
          <div>
            <h2 className="text-3xl md:text-4xl font-extrabold text-white">Hamari Kahaani</h2>
            <p className="mt-4 text-slate-300 leading-relaxed">
              OnlineCricketID ki shuruaat {SITE.since} me hui thi - jab India me online sports exchange ek nayi cheez thi. Hamare founders ne dekha ki players ko sahi guidance, fast ID activation aur trusted withdrawal kahin nahi mil raha tha.
            </p>
            <p className="mt-4 text-slate-300 leading-relaxed">
              Tabse leke aaj tak hum ek hi mission par chal rahe hain — har player ko surakshit, fair aur fun gaming experience dena. Aaj 50,000+ users daily OnlineCricketID par cricket, casino aur live sports exchange ka maza lete hain.
            </p>
            <div className="mt-6 grid grid-cols-3 gap-4">
              <div className="card-dark p-4 text-center"><div className="text-2xl font-extrabold text-amber-400">10+</div><div className="text-[11px] text-slate-400 uppercase tracking-wide mt-1">Saal Trusted</div></div>
              <div className="card-dark p-4 text-center"><div className="text-2xl font-extrabold text-amber-400">50K+</div><div className="text-[11px] text-slate-400 uppercase tracking-wide mt-1">Users</div></div>
              <div className="card-dark p-4 text-center"><div className="text-2xl font-extrabold text-amber-400">650+</div><div className="text-[11px] text-slate-400 uppercase tracking-wide mt-1">Games</div></div>
            </div>
          </div>
          <div className="relative rounded-3xl overflow-hidden border border-amber-500/20">
            <img src={IMAGES.fans} alt="Cricket fans" className="w-full h-[420px] object-cover" />
            <div className="absolute inset-0 bg-gradient-to-t from-[#0a1226]/80 to-transparent" />
          </div>
        </div>
      </section>

      <section className="section-pad bg-gradient-to-b from-transparent via-[#0c1530]/40 to-transparent">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 grid md:grid-cols-2 gap-5">
          <div className="card-dark p-7">
            <div className="w-12 h-12 rounded-xl bg-amber-500/15 border border-amber-500/30 flex items-center justify-center"><Target className="w-6 h-6 text-amber-400" /></div>
            <h3 className="mt-4 text-2xl font-bold text-white">Our Mission</h3>
            <p className="mt-3 text-slate-300 leading-relaxed">Har Indian cricket lover ko ek safe, transparent aur fast platform dena - jahan wo apne passion ko bina kisi tension ke enjoy kar sake. Hum sirf gaming nahi, ek poora ecosystem build kar rahe hain.</p>
          </div>
          <div className="card-dark p-7">
            <div className="w-12 h-12 rounded-xl bg-amber-500/15 border border-amber-500/30 flex items-center justify-center"><Award className="w-6 h-6 text-amber-400" /></div>
            <h3 className="mt-4 text-2xl font-bold text-white">Our Vision</h3>
            <p className="mt-3 text-slate-300 leading-relaxed">India ka No.1 trusted sports exchange aur Cricket ID provider banna - jahan 1 million+ users responsible gaming ke saath apne skills ka use karke earning kar sake.</p>
          </div>
        </div>
      </section>

      <section className="section-pad">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center max-w-2xl mx-auto">
            <h2 className="text-3xl md:text-4xl font-extrabold text-white">Hamari Core Values</h2>
            <p className="mt-3 text-slate-400">Wo principles jo OnlineCricketID ko aaj 10+ saal se relevant aur trusted bana rahe hain.</p>
          </div>
          <div className="mt-10 grid sm:grid-cols-2 lg:grid-cols-4 gap-5">
            {values.map((v) => (
              <div key={v.title} className="card-dark p-6">
                <div className="w-12 h-12 rounded-xl bg-amber-500/15 border border-amber-500/30 flex items-center justify-center"><v.icon className="w-6 h-6 text-amber-400" /></div>
                <h3 className="mt-4 text-lg font-bold text-white">{v.title}</h3>
                <p className="mt-2 text-sm text-slate-400 leading-relaxed">{v.desc}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      <section className="section-pad bg-gradient-to-b from-transparent via-[#0c1530]/40 to-transparent">
        <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="card-dark p-7 md:p-10 grid md:grid-cols-[140px_1fr] gap-6 items-start">
            <div className="w-32 h-32 rounded-2xl bg-gradient-to-br from-amber-400 to-amber-700 flex items-center justify-center text-5xl font-extrabold text-[#0a1226]">A</div>
            <div>
              <h3 className="text-2xl font-bold text-white">Anna — Founder & Cricket ID Expert</h3>
              <p className="text-amber-300 text-sm mt-1">10+ years in online sports exchange industry</p>
              <p className="mt-4 text-slate-300 leading-relaxed">
                “I started this journey because Indian players deserved a transparent, fast aur trustworthy ID provider. Aaj OnlineCricketID par 50,000+ users daily play karte hain - har user ki choti se choti problem mere liye personal hai. Hamari team din-raat kaam karti hai taaki aap ko ek seamless experience mile.”
              </p>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
}
